import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import API from "@beardeddevops/react.api";
import {confirmAlert} from "react-confirm-alert";
import {Button} from "reactstrap";

/**
 * @property {Manager_Tasks_Object} state
 * @property {object} model
 * @property {Manager_Tasks_Properties} model.properties
 *
 */

export default class BulkAddTask extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Manager_Tasks._name);
		this.state.task_role = this.props.task_role;
		this.state.suggestions= [];
		this.state.showSuggestions = false;
		this.state.highlightedIndex = 0;
		this.state.loading = false;
		this.state.notify_users = [];
		this.debounceTimer = null;
		this.textareaRef = React.createRef();
		this.suggestionRefs = [];
	}

	showProjects = () => {
		if (!this.state.description) {
			return;
		}
		const projects = this.state.description.split(';').filter(Boolean);
		// console.log(projects,'PROJS')

		let divs = [
			<div key={'descriptor'}><span style={{fontWeight: 'bold', fontSize: 15}}>Title</span><br/><span>Description</span></div>,
			<br/>
		];

		for (let i = 0; i < projects.length; i += 1) {
			const parts = projects[i].split('|');
			if (!parts[0] || !parts[1]) {
				continue;
			}
			divs.push(<div key={'proj' + i}><span style={{fontWeight: 'bold', fontSize: 15}}>{parts[0]}</span><br/><span>{parts[1]}</span></div>)
			divs.push(<br/>)
		}

			return divs
	}

	handleSubmit = () => {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div tabIndex={0} ref={(el) => el && el.focus()} style={{backgroundColor: "white", padding: '25px'}} onKeyDown={(e) => this.handleConfirm(e, onClose)}>
						<h2>Confirm Projects</h2>
						{this.showProjects()}
						<br />
						<div>
							<Button color="primary" onClick={() => {super.handleSubmit(); onClose();}} style={{marginRight: '10px'}}>Confirm (Enter)</Button>
							<Button color="secondary" onClick={onClose}>No (Tab)</Button>
						</div>
					</div>
				);
			}
		});
	}

	fetchSuggestions = async (query) => {
		this.setState({ loading: true });
		try {

			let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
			model.search = query;
			model.filter = {'fromBulkAdd': true}
			const data = await model.submit(null, API.RequestType.READ_ALL);

			this.setState({ suggestions: data.items, loading: false, highlightedIndex: 0 });
		} catch (err) {
			console.error('Fetch error:', err);
			this.setState({ suggestions: [], loading: false });
		}
	};

	handleChange = (e) => {
		const value = e.target.value;
		this.setState({ description: value });

		const match = value.match(/@(\w*)$/);
		if (match) {
			const query = match[1];
			clearTimeout(this.debounceTimer);
			this.debounceTimer = setTimeout(() => {
				this.fetchSuggestions(query);
				this.setState({ showSuggestions: true });
			}, 300);
		} else {
			this.setState({
				showSuggestions: false,
				suggestions: [],
				highlightedIndex: 0
			});
		}
	};

	handleKeyDown = (e) => {
		const { highlightedIndex, suggestions, showSuggestions } = this.state;

		if (showSuggestions && suggestions.length > 0) {
			if (e.key === 'ArrowDown') {
				e.preventDefault();
				const nextIndex = (highlightedIndex + 1) % suggestions.length;
				this.setState({ highlightedIndex: nextIndex }, this.scrollToHighlighted);
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				const prevIndex = (highlightedIndex - 1 + suggestions.length) % suggestions.length;
				this.setState({ highlightedIndex: prevIndex }, this.scrollToHighlighted);
			} else if (e.key === 'Enter') {
				e.preventDefault();
				this.selectSuggestion(suggestions[highlightedIndex]);
			} else if (e.key === 'Tab') {
				e.preventDefault();
				if (e.shiftKey) {
					// Shift + Tab (go backwards)
					const prevIndex = (highlightedIndex - 1 + suggestions.length) % suggestions.length;
					this.setState({ highlightedIndex: prevIndex }, this.scrollToHighlighted);
				} else {
					// Regular Tab (go forward)
					const nextIndex = (highlightedIndex + 1) % suggestions.length;
					this.setState({ highlightedIndex: nextIndex }, this.scrollToHighlighted);
				}
			}else if (e.key === 'Escape') {
				this.setState({ showSuggestions: false });
			}
		}
	};

	handleConfirm = (e, onClose) => {
		if (e.key === 'Enter') {
			super.handleSubmit();
			onClose();
			e.preventDefault();
		} else if (e.key === 'Tab') {
			onClose();
			e.preventDefault();
		}
	};

	scrollToHighlighted = () => {
		const el = this.suggestionRefs[this.state.highlightedIndex];
		if (el && el.scrollIntoView) {
			el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
		}
	};

	selectSuggestion = (suggestion) => {
		//text to add to the project
		const updated = this.state.description.replace(/@(\w*)$/, `@${suggestion.name_first}${suggestion.name_last[0]}`);
		//add their pkey so once submitted the backend can deal with stuff
		this.state.notify_users.push(suggestion.pkey);
		this.setState({
			description: updated,
			showSuggestions: false,
			suggestions: [],
			highlightedIndex: 0
		});
		this.textareaRef.current.focus();
	};

	renderSuggestions = () => {
		const { suggestions, loading, highlightedIndex } = this.state;

		this.suggestionRefs = [];

		if (loading) return <li style={styles.item}>Loading...</li>;
		if (suggestions.length === 0) return <li style={styles.item}>No suggestions</li>;

		return suggestions.map((suggestion, index) => (
			<li
				key={index}
				ref={(el) => (this.suggestionRefs[index] = el)}
				onClick={() => this.selectSuggestion(suggestion)}
				style={{
					...styles.item,
					backgroundColor: index === highlightedIndex ? '#f0f0f0' : 'white',
					fontWeight: index === highlightedIndex ? 'bold' : 'normal',
					cursor: 'pointer'
				}}
			>
				{suggestion.name_first} {suggestion.name_last} - {suggestion.main_role_name}
			</li>
		));
	};



	form = () => {
		/**
		 * @param {Manager_Tasks_Properties} data
		 */
		let {properties} = this.model;

		/**
		 * @type {Manager_Tasks_Object} object
		 */
		let object = this.state;
		return (
			<fieldset>
				<div className={'row'}>
					{/*Maybe put a header here with a legend/explanation of how to use*/}
					<div className={'col-12'}>
						<div>
							<textarea
								ref={this.textareaRef}
								value={this.state.description}
								onChange={this.handleChange}
								onKeyDown={this.handleKeyDown}
								placeholder={"@Name Title|Description;Title2|description2"}
								rows={8}
								style={styles.textarea}
								required={true}
							/>
							{this.state.showSuggestions && (
								<ul style={styles.suggestionListBelow}>
									{this.renderSuggestions()}
								</ul>
							)}
						</div>

					</div>
				</div>
			</fieldset>
		)
	}
}

const styles = {
	textarea: {
		width: '100%',
		padding: '10px',
		fontSize: '14px',
		boxSizing: 'border-box',
		resize: 'vertical'
	},
	suggestionListBelow: {
		position: 'absolute',
		top: '100%',
		left: 0,
		width: '100%',
		backgroundColor: 'white',
		border: '1px solid #ccc',
		listStyle: 'none',
		margin: 0,
		padding: '4px 0',
		maxHeight: '150px',
		overflowY: 'auto',
		zIndex: 1000
	},
	item: {
		padding: '8px 12px',
		borderBottom: '1px solid #eee'
	}
};